import { emptySplitApi as api } from "./emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    mallServiceListMalls: build.query<
      MallServiceListMallsApiResponse,
      MallServiceListMallsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/malls`,
        params: {
          page_size: queryArg.pageSize,
          page_number: queryArg.pageNumber,
          filter: queryArg.filter,
          order_by: queryArg.orderBy,
          show_deleted: queryArg.showDeleted,
          read_mask: queryArg.readMask,
        },
      }),
    }),
    mallServiceCreateMall: build.mutation<
      MallServiceCreateMallApiResponse,
      MallServiceCreateMallApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/malls`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1Mall,
      }),
    }),
    mallServiceGetMall: build.query<
      MallServiceGetMallApiResponse,
      MallServiceGetMallApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/malls/${queryArg.mall}`,
        params: { read_mask: queryArg.readMask },
      }),
    }),
    mallServiceDeleteMall: build.mutation<
      MallServiceDeleteMallApiResponse,
      MallServiceDeleteMallApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/malls/${queryArg.mall}`,
        method: "DELETE",
      }),
    }),
    mallServiceUpdateMall: build.mutation<
      MallServiceUpdateMallApiResponse,
      MallServiceUpdateMallApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/malls/${queryArg.mall}`,
        method: "PATCH",
        body: queryArg.factoryDigitalmallBackofficeV1Mall,
        params: { update_mask: queryArg.updateMask },
      }),
    }),
    mallServiceHarddeleteMall: build.mutation<
      MallServiceHarddeleteMallApiResponse,
      MallServiceHarddeleteMallApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/malls/${queryArg.mall}:harddelete`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1HarddeleteMallRequest,
      }),
    }),
    mallServiceUndeleteMall: build.mutation<
      MallServiceUndeleteMallApiResponse,
      MallServiceUndeleteMallApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/malls/${queryArg.mall}:undelete`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1UndeleteMallRequest,
      }),
    }),
    mallServiceBatchCreateMalls: build.mutation<
      MallServiceBatchCreateMallsApiResponse,
      MallServiceBatchCreateMallsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/malls:batchCreate`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1BatchCreateMallsRequest,
      }),
    }),
    mallServiceBatchGetMalls: build.query<
      MallServiceBatchGetMallsApiResponse,
      MallServiceBatchGetMallsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/malls:batchGet`,
        params: { names: queryArg.names, read_mask: queryArg.readMask },
      }),
    }),
    mallServiceBatchUpdateMalls: build.mutation<
      MallServiceBatchUpdateMallsApiResponse,
      MallServiceBatchUpdateMallsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/malls:batchUpdate`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1BatchUpdateMallsRequest,
      }),
    }),
    productServiceListProducts: build.query<
      ProductServiceListProductsApiResponse,
      ProductServiceListProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/products`,
        params: {
          page_size: queryArg.pageSize,
          page_number: queryArg.pageNumber,
          filter: queryArg.filter,
          order_by: queryArg.orderBy,
          show_deleted: queryArg.showDeleted,
          read_mask: queryArg.readMask,
        },
      }),
    }),
    productServiceCreateProduct: build.mutation<
      ProductServiceCreateProductApiResponse,
      ProductServiceCreateProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/products`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1Product,
      }),
    }),
    productServiceGetProduct: build.query<
      ProductServiceGetProductApiResponse,
      ProductServiceGetProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/products/${queryArg.product}`,
        params: { read_mask: queryArg.readMask },
      }),
    }),
    productServiceDeleteProduct: build.mutation<
      ProductServiceDeleteProductApiResponse,
      ProductServiceDeleteProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/products/${queryArg.product}`,
        method: "DELETE",
      }),
    }),
    productServiceUpdateProduct: build.mutation<
      ProductServiceUpdateProductApiResponse,
      ProductServiceUpdateProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/products/${queryArg.product}`,
        method: "PATCH",
        body: queryArg.factoryDigitalmallBackofficeV1Product,
        params: { update_mask: queryArg.updateMask },
      }),
    }),
    productServiceHarddeleteProduct: build.mutation<
      ProductServiceHarddeleteProductApiResponse,
      ProductServiceHarddeleteProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/products/${queryArg.product}:harddelete`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1HarddeleteProductRequest,
      }),
    }),
    productServiceUndeleteProduct: build.mutation<
      ProductServiceUndeleteProductApiResponse,
      ProductServiceUndeleteProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/products/${queryArg.product}:undelete`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1UndeleteProductRequest,
      }),
    }),
    productServiceBatchCreateProducts: build.mutation<
      ProductServiceBatchCreateProductsApiResponse,
      ProductServiceBatchCreateProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/products:batchCreate`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1BatchCreateProductsRequest,
      }),
    }),
    productServiceBatchGetProducts: build.query<
      ProductServiceBatchGetProductsApiResponse,
      ProductServiceBatchGetProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/products:batchGet`,
        params: { names: queryArg.names, read_mask: queryArg.readMask },
      }),
    }),
    productServiceBatchUpdateProducts: build.mutation<
      ProductServiceBatchUpdateProductsApiResponse,
      ProductServiceBatchUpdateProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/products:batchUpdate`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1BatchUpdateProductsRequest,
      }),
    }),
    retailerServiceListRetailers: build.query<
      RetailerServiceListRetailersApiResponse,
      RetailerServiceListRetailersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/retailers`,
        params: {
          page_size: queryArg.pageSize,
          page_number: queryArg.pageNumber,
          filter: queryArg.filter,
          order_by: queryArg.orderBy,
          show_deleted: queryArg.showDeleted,
          read_mask: queryArg.readMask,
        },
      }),
    }),
    retailerServiceCreateRetailer: build.mutation<
      RetailerServiceCreateRetailerApiResponse,
      RetailerServiceCreateRetailerApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/retailers`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1Retailer,
      }),
    }),
    retailerServiceGetRetailer: build.query<
      RetailerServiceGetRetailerApiResponse,
      RetailerServiceGetRetailerApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/retailers/${queryArg.retailer}`,
        params: { read_mask: queryArg.readMask },
      }),
    }),
    retailerServiceDeleteRetailer: build.mutation<
      RetailerServiceDeleteRetailerApiResponse,
      RetailerServiceDeleteRetailerApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/retailers/${queryArg.retailer}`,
        method: "DELETE",
      }),
    }),
    retailerServiceUpdateRetailer: build.mutation<
      RetailerServiceUpdateRetailerApiResponse,
      RetailerServiceUpdateRetailerApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/retailers/${queryArg.retailer}`,
        method: "PATCH",
        body: queryArg.factoryDigitalmallBackofficeV1Retailer,
        params: { update_mask: queryArg.updateMask },
      }),
    }),
    retailerServiceHarddeleteRetailer: build.mutation<
      RetailerServiceHarddeleteRetailerApiResponse,
      RetailerServiceHarddeleteRetailerApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/retailers/${queryArg.retailer}:harddelete`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1HarddeleteRetailerRequest,
      }),
    }),
    retailerServiceUndeleteRetailer: build.mutation<
      RetailerServiceUndeleteRetailerApiResponse,
      RetailerServiceUndeleteRetailerApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/retailers/${queryArg.retailer}:undelete`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1UndeleteRetailerRequest,
      }),
    }),
    retailerServiceBatchCreateRetailers: build.mutation<
      RetailerServiceBatchCreateRetailersApiResponse,
      RetailerServiceBatchCreateRetailersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/retailers:batchCreate`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1BatchCreateRetailersRequest,
      }),
    }),
    retailerServiceBatchGetRetailers: build.query<
      RetailerServiceBatchGetRetailersApiResponse,
      RetailerServiceBatchGetRetailersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/retailers:batchGet`,
        params: { names: queryArg.names, read_mask: queryArg.readMask },
      }),
    }),
    retailerServiceBatchUpdateRetailers: build.mutation<
      RetailerServiceBatchUpdateRetailersApiResponse,
      RetailerServiceBatchUpdateRetailersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/retailers:batchUpdate`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1BatchUpdateRetailersRequest,
      }),
    }),
    serviceServiceListServices: build.query<
      ServiceServiceListServicesApiResponse,
      ServiceServiceListServicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/services`,
        params: {
          page_size: queryArg.pageSize,
          page_number: queryArg.pageNumber,
          filter: queryArg.filter,
          order_by: queryArg.orderBy,
          show_deleted: queryArg.showDeleted,
          read_mask: queryArg.readMask,
        },
      }),
    }),
    serviceServiceCreateService: build.mutation<
      ServiceServiceCreateServiceApiResponse,
      ServiceServiceCreateServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/services`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1Service,
      }),
    }),
    serviceServiceGetService: build.query<
      ServiceServiceGetServiceApiResponse,
      ServiceServiceGetServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/services/${queryArg.service}`,
        params: { read_mask: queryArg.readMask },
      }),
    }),
    serviceServiceDeleteService: build.mutation<
      ServiceServiceDeleteServiceApiResponse,
      ServiceServiceDeleteServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/services/${queryArg.service}`,
        method: "DELETE",
      }),
    }),
    serviceServiceUpdateService: build.mutation<
      ServiceServiceUpdateServiceApiResponse,
      ServiceServiceUpdateServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/services/${queryArg.service}`,
        method: "PATCH",
        body: queryArg.factoryDigitalmallBackofficeV1Service,
        params: { update_mask: queryArg.updateMask },
      }),
    }),
    serviceServiceHarddeleteService: build.mutation<
      ServiceServiceHarddeleteServiceApiResponse,
      ServiceServiceHarddeleteServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/services/${queryArg.service}:harddelete`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1HarddeleteServiceRequest,
      }),
    }),
    serviceServiceUndeleteService: build.mutation<
      ServiceServiceUndeleteServiceApiResponse,
      ServiceServiceUndeleteServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/services/${queryArg.service}:undelete`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1UndeleteServiceRequest,
      }),
    }),
    serviceServiceBatchCreateServices: build.mutation<
      ServiceServiceBatchCreateServicesApiResponse,
      ServiceServiceBatchCreateServicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/services:batchCreate`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1BatchCreateServicesRequest,
      }),
    }),
    serviceServiceBatchGetServices: build.query<
      ServiceServiceBatchGetServicesApiResponse,
      ServiceServiceBatchGetServicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/services:batchGet`,
        params: { names: queryArg.names, read_mask: queryArg.readMask },
      }),
    }),
    serviceServiceBatchUpdateServices: build.mutation<
      ServiceServiceBatchUpdateServicesApiResponse,
      ServiceServiceBatchUpdateServicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/services:batchUpdate`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1BatchUpdateServicesRequest,
      }),
    }),
    stockServiceListStocks: build.query<
      StockServiceListStocksApiResponse,
      StockServiceListStocksApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stocks`,
        params: {
          page_size: queryArg.pageSize,
          page_number: queryArg.pageNumber,
          filter: queryArg.filter,
          order_by: queryArg.orderBy,
          show_deleted: queryArg.showDeleted,
          read_mask: queryArg.readMask,
        },
      }),
    }),
    stockServiceCreateStock: build.mutation<
      StockServiceCreateStockApiResponse,
      StockServiceCreateStockApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stocks`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1Stock,
      }),
    }),
    stockServiceGetStock: build.query<
      StockServiceGetStockApiResponse,
      StockServiceGetStockApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stocks/${queryArg.stock}`,
        params: { read_mask: queryArg.readMask },
      }),
    }),
    stockServiceDeleteStock: build.mutation<
      StockServiceDeleteStockApiResponse,
      StockServiceDeleteStockApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stocks/${queryArg.stock}`,
        method: "DELETE",
      }),
    }),
    stockServiceUpdateStock: build.mutation<
      StockServiceUpdateStockApiResponse,
      StockServiceUpdateStockApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stocks/${queryArg.stock}`,
        method: "PATCH",
        body: queryArg.factoryDigitalmallBackofficeV1Stock,
        params: { update_mask: queryArg.updateMask },
      }),
    }),
    stockServiceHarddeleteStock: build.mutation<
      StockServiceHarddeleteStockApiResponse,
      StockServiceHarddeleteStockApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stocks/${queryArg.stock}:harddelete`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1HarddeleteStockRequest,
      }),
    }),
    stockServiceUndeleteStock: build.mutation<
      StockServiceUndeleteStockApiResponse,
      StockServiceUndeleteStockApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stocks/${queryArg.stock}:undelete`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1UndeleteStockRequest,
      }),
    }),
    stockServiceBatchCreateStocks: build.mutation<
      StockServiceBatchCreateStocksApiResponse,
      StockServiceBatchCreateStocksApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stocks:batchCreate`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1BatchCreateStocksRequest,
      }),
    }),
    stockServiceBatchGetStocks: build.query<
      StockServiceBatchGetStocksApiResponse,
      StockServiceBatchGetStocksApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stocks:batchGet`,
        params: { names: queryArg.names, read_mask: queryArg.readMask },
      }),
    }),
    stockServiceBatchUpdateStocks: build.mutation<
      StockServiceBatchUpdateStocksApiResponse,
      StockServiceBatchUpdateStocksApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stocks:batchUpdate`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1BatchUpdateStocksRequest,
      }),
    }),
    storeServiceListStores: build.query<
      StoreServiceListStoresApiResponse,
      StoreServiceListStoresApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stores`,
        params: {
          page_size: queryArg.pageSize,
          page_number: queryArg.pageNumber,
          filter: queryArg.filter,
          order_by: queryArg.orderBy,
          show_deleted: queryArg.showDeleted,
          read_mask: queryArg.readMask,
        },
      }),
    }),
    storeServiceCreateStore: build.mutation<
      StoreServiceCreateStoreApiResponse,
      StoreServiceCreateStoreApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stores`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1Store,
      }),
    }),
    storeServiceGetStore: build.query<
      StoreServiceGetStoreApiResponse,
      StoreServiceGetStoreApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stores/${queryArg.store}`,
        params: { read_mask: queryArg.readMask },
      }),
    }),
    storeServiceDeleteStore: build.mutation<
      StoreServiceDeleteStoreApiResponse,
      StoreServiceDeleteStoreApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stores/${queryArg.store}`,
        method: "DELETE",
      }),
    }),
    storeServiceUpdateStore: build.mutation<
      StoreServiceUpdateStoreApiResponse,
      StoreServiceUpdateStoreApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stores/${queryArg.store}`,
        method: "PATCH",
        body: queryArg.factoryDigitalmallBackofficeV1Store,
        params: { update_mask: queryArg.updateMask },
      }),
    }),
    storeServiceHarddeleteStore: build.mutation<
      StoreServiceHarddeleteStoreApiResponse,
      StoreServiceHarddeleteStoreApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stores/${queryArg.store}:harddelete`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1HarddeleteStoreRequest,
      }),
    }),
    storeServiceUndeleteStore: build.mutation<
      StoreServiceUndeleteStoreApiResponse,
      StoreServiceUndeleteStoreApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stores/${queryArg.store}:undelete`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1UndeleteStoreRequest,
      }),
    }),
    storeServiceBatchCreateStores: build.mutation<
      StoreServiceBatchCreateStoresApiResponse,
      StoreServiceBatchCreateStoresApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stores:batchCreate`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1BatchCreateStoresRequest,
      }),
    }),
    storeServiceBatchGetStores: build.query<
      StoreServiceBatchGetStoresApiResponse,
      StoreServiceBatchGetStoresApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stores:batchGet`,
        params: { names: queryArg.names, read_mask: queryArg.readMask },
      }),
    }),
    storeServiceBatchUpdateStores: build.mutation<
      StoreServiceBatchUpdateStoresApiResponse,
      StoreServiceBatchUpdateStoresApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/stores:batchUpdate`,
        method: "POST",
        body: queryArg.factoryDigitalmallBackofficeV1BatchUpdateStoresRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as genericApiGenerated };
export type MallServiceListMallsApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1ListMallsResponse;
export type MallServiceListMallsApiArg = {
  /** comment */
  pageSize?: number;
  /** comment */
  pageNumber?: number;
  /** Should follow the Filtering best practices defined by Google AIP here https://google.aip.dev/160 */
  filter?: string;
  /** comment */
  orderBy?: string;
  /** comment */
  showDeleted?: boolean;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type MallServiceCreateMallApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Mall;
export type MallServiceCreateMallApiArg = {
  factoryDigitalmallBackofficeV1Mall: FactoryDigitalmallBackofficeV1Mall;
};
export type MallServiceGetMallApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Mall;
export type MallServiceGetMallApiArg = {
  /** The mall id. */
  mall: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type MallServiceDeleteMallApiResponse = /** status 200 OK */ string;
export type MallServiceDeleteMallApiArg = {
  /** The mall id. */
  mall: string;
};
export type MallServiceUpdateMallApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Mall;
export type MallServiceUpdateMallApiArg = {
  /** The mall id. */
  mall: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  updateMask?: string;
  factoryDigitalmallBackofficeV1Mall: FactoryDigitalmallBackofficeV1Mall;
};
export type MallServiceHarddeleteMallApiResponse = /** status 200 OK */ string;
export type MallServiceHarddeleteMallApiArg = {
  /** The mall id. */
  mall: string;
  factoryDigitalmallBackofficeV1HarddeleteMallRequest: FactoryDigitalmallBackofficeV1HarddeleteMallRequest;
};
export type MallServiceUndeleteMallApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Mall;
export type MallServiceUndeleteMallApiArg = {
  /** The mall id. */
  mall: string;
  factoryDigitalmallBackofficeV1UndeleteMallRequest: FactoryDigitalmallBackofficeV1UndeleteMallRequest;
};
export type MallServiceBatchCreateMallsApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchCreateMallsResponse;
export type MallServiceBatchCreateMallsApiArg = {
  factoryDigitalmallBackofficeV1BatchCreateMallsRequest: FactoryDigitalmallBackofficeV1BatchCreateMallsRequest;
};
export type MallServiceBatchGetMallsApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchGetMallsResponse;
export type MallServiceBatchGetMallsApiArg = {
  /** The names of the books to retrieve. A maximum of 1000 books can be retrieved in a batch. Format: publishers/{publisher}/books/{book} */
  names?: string[];
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type MallServiceBatchUpdateMallsApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchUpdateMallsResponse;
export type MallServiceBatchUpdateMallsApiArg = {
  factoryDigitalmallBackofficeV1BatchUpdateMallsRequest: FactoryDigitalmallBackofficeV1BatchUpdateMallsRequest;
};
export type ProductServiceListProductsApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1ListProductsResponse;
export type ProductServiceListProductsApiArg = {
  /** comment */
  pageSize?: number;
  /** comment */
  pageNumber?: number;
  /** Should follow the Filtering best practices defined by Google AIP here https://google.aip.dev/160 */
  filter?: string;
  /** comment */
  orderBy?: string;
  /** comment */
  showDeleted?: boolean;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type ProductServiceCreateProductApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Product;
export type ProductServiceCreateProductApiArg = {
  factoryDigitalmallBackofficeV1Product: FactoryDigitalmallBackofficeV1Product;
};
export type ProductServiceGetProductApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Product;
export type ProductServiceGetProductApiArg = {
  /** The product id. */
  product: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type ProductServiceDeleteProductApiResponse =
  /** status 200 OK */ string;
export type ProductServiceDeleteProductApiArg = {
  /** The product id. */
  product: string;
};
export type ProductServiceUpdateProductApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Product;
export type ProductServiceUpdateProductApiArg = {
  /** The product id. */
  product: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  updateMask?: string;
  factoryDigitalmallBackofficeV1Product: FactoryDigitalmallBackofficeV1Product;
};
export type ProductServiceHarddeleteProductApiResponse =
  /** status 200 OK */ string;
export type ProductServiceHarddeleteProductApiArg = {
  /** The product id. */
  product: string;
  factoryDigitalmallBackofficeV1HarddeleteProductRequest: FactoryDigitalmallBackofficeV1HarddeleteProductRequest;
};
export type ProductServiceUndeleteProductApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Product;
export type ProductServiceUndeleteProductApiArg = {
  /** The product id. */
  product: string;
  factoryDigitalmallBackofficeV1UndeleteProductRequest: FactoryDigitalmallBackofficeV1UndeleteProductRequest;
};
export type ProductServiceBatchCreateProductsApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchCreateProductsResponse;
export type ProductServiceBatchCreateProductsApiArg = {
  factoryDigitalmallBackofficeV1BatchCreateProductsRequest: FactoryDigitalmallBackofficeV1BatchCreateProductsRequest;
};
export type ProductServiceBatchGetProductsApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchGetProductsResponse;
export type ProductServiceBatchGetProductsApiArg = {
  /** The names of the books to retrieve. A maximum of 1000 books can be retrieved in a batch. Format: publishers/{publisher}/books/{book} */
  names?: string[];
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type ProductServiceBatchUpdateProductsApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchUpdateProductsResponse;
export type ProductServiceBatchUpdateProductsApiArg = {
  factoryDigitalmallBackofficeV1BatchUpdateProductsRequest: FactoryDigitalmallBackofficeV1BatchUpdateProductsRequest;
};
export type RetailerServiceListRetailersApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1ListRetailersResponse;
export type RetailerServiceListRetailersApiArg = {
  /** comment */
  pageSize?: number;
  /** comment */
  pageNumber?: number;
  /** Should follow the Filtering best practices defined by Google AIP here https://google.aip.dev/160 */
  filter?: string;
  /** comment */
  orderBy?: string;
  /** comment */
  showDeleted?: boolean;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type RetailerServiceCreateRetailerApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Retailer;
export type RetailerServiceCreateRetailerApiArg = {
  factoryDigitalmallBackofficeV1Retailer: FactoryDigitalmallBackofficeV1Retailer;
};
export type RetailerServiceGetRetailerApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Retailer;
export type RetailerServiceGetRetailerApiArg = {
  /** The retailer id. */
  retailer: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type RetailerServiceDeleteRetailerApiResponse =
  /** status 200 OK */ string;
export type RetailerServiceDeleteRetailerApiArg = {
  /** The retailer id. */
  retailer: string;
};
export type RetailerServiceUpdateRetailerApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Retailer;
export type RetailerServiceUpdateRetailerApiArg = {
  /** The retailer id. */
  retailer: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  updateMask?: string;
  factoryDigitalmallBackofficeV1Retailer: FactoryDigitalmallBackofficeV1Retailer;
};
export type RetailerServiceHarddeleteRetailerApiResponse =
  /** status 200 OK */ string;
export type RetailerServiceHarddeleteRetailerApiArg = {
  /** The retailer id. */
  retailer: string;
  factoryDigitalmallBackofficeV1HarddeleteRetailerRequest: FactoryDigitalmallBackofficeV1HarddeleteRetailerRequest;
};
export type RetailerServiceUndeleteRetailerApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Retailer;
export type RetailerServiceUndeleteRetailerApiArg = {
  /** The retailer id. */
  retailer: string;
  factoryDigitalmallBackofficeV1UndeleteRetailerRequest: FactoryDigitalmallBackofficeV1UndeleteRetailerRequest;
};
export type RetailerServiceBatchCreateRetailersApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchCreateRetailersResponse;
export type RetailerServiceBatchCreateRetailersApiArg = {
  factoryDigitalmallBackofficeV1BatchCreateRetailersRequest: FactoryDigitalmallBackofficeV1BatchCreateRetailersRequest;
};
export type RetailerServiceBatchGetRetailersApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchGetRetailersResponse;
export type RetailerServiceBatchGetRetailersApiArg = {
  /** The names of the books to retrieve. A maximum of 1000 books can be retrieved in a batch. Format: publishers/{publisher}/books/{book} */
  names?: string[];
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type RetailerServiceBatchUpdateRetailersApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchUpdateRetailersResponse;
export type RetailerServiceBatchUpdateRetailersApiArg = {
  factoryDigitalmallBackofficeV1BatchUpdateRetailersRequest: FactoryDigitalmallBackofficeV1BatchUpdateRetailersRequest;
};
export type ServiceServiceListServicesApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1ListServicesResponse;
export type ServiceServiceListServicesApiArg = {
  /** comment */
  pageSize?: number;
  /** comment */
  pageNumber?: number;
  /** Should follow the Filtering best practices defined by Google AIP here https://google.aip.dev/160 */
  filter?: string;
  /** comment */
  orderBy?: string;
  /** comment */
  showDeleted?: boolean;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type ServiceServiceCreateServiceApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Service;
export type ServiceServiceCreateServiceApiArg = {
  factoryDigitalmallBackofficeV1Service: FactoryDigitalmallBackofficeV1Service;
};
export type ServiceServiceGetServiceApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Service;
export type ServiceServiceGetServiceApiArg = {
  /** The service id. */
  service: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type ServiceServiceDeleteServiceApiResponse =
  /** status 200 OK */ string;
export type ServiceServiceDeleteServiceApiArg = {
  /** The service id. */
  service: string;
};
export type ServiceServiceUpdateServiceApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Service;
export type ServiceServiceUpdateServiceApiArg = {
  /** The service id. */
  service: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  updateMask?: string;
  factoryDigitalmallBackofficeV1Service: FactoryDigitalmallBackofficeV1Service;
};
export type ServiceServiceHarddeleteServiceApiResponse =
  /** status 200 OK */ string;
export type ServiceServiceHarddeleteServiceApiArg = {
  /** The service id. */
  service: string;
  factoryDigitalmallBackofficeV1HarddeleteServiceRequest: FactoryDigitalmallBackofficeV1HarddeleteServiceRequest;
};
export type ServiceServiceUndeleteServiceApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Service;
export type ServiceServiceUndeleteServiceApiArg = {
  /** The service id. */
  service: string;
  factoryDigitalmallBackofficeV1UndeleteServiceRequest: FactoryDigitalmallBackofficeV1UndeleteServiceRequest;
};
export type ServiceServiceBatchCreateServicesApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchCreateServicesResponse;
export type ServiceServiceBatchCreateServicesApiArg = {
  factoryDigitalmallBackofficeV1BatchCreateServicesRequest: FactoryDigitalmallBackofficeV1BatchCreateServicesRequest;
};
export type ServiceServiceBatchGetServicesApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchGetServicesResponse;
export type ServiceServiceBatchGetServicesApiArg = {
  /** The names of the books to retrieve. A maximum of 1000 books can be retrieved in a batch. Format: publishers/{publisher}/books/{book} */
  names?: string[];
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type ServiceServiceBatchUpdateServicesApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchUpdateServicesResponse;
export type ServiceServiceBatchUpdateServicesApiArg = {
  factoryDigitalmallBackofficeV1BatchUpdateServicesRequest: FactoryDigitalmallBackofficeV1BatchUpdateServicesRequest;
};
export type StockServiceListStocksApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1ListStocksResponse;
export type StockServiceListStocksApiArg = {
  /** comment */
  pageSize?: number;
  /** comment */
  pageNumber?: number;
  /** Should follow the Filtering best practices defined by Google AIP here https://google.aip.dev/160 */
  filter?: string;
  /** comment */
  orderBy?: string;
  /** comment */
  showDeleted?: boolean;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type StockServiceCreateStockApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Stock;
export type StockServiceCreateStockApiArg = {
  factoryDigitalmallBackofficeV1Stock: FactoryDigitalmallBackofficeV1Stock;
};
export type StockServiceGetStockApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Stock;
export type StockServiceGetStockApiArg = {
  /** The stock id. */
  stock: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type StockServiceDeleteStockApiResponse = /** status 200 OK */ string;
export type StockServiceDeleteStockApiArg = {
  /** The stock id. */
  stock: string;
};
export type StockServiceUpdateStockApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Stock;
export type StockServiceUpdateStockApiArg = {
  /** The stock id. */
  stock: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  updateMask?: string;
  factoryDigitalmallBackofficeV1Stock: FactoryDigitalmallBackofficeV1Stock;
};
export type StockServiceHarddeleteStockApiResponse =
  /** status 200 OK */ string;
export type StockServiceHarddeleteStockApiArg = {
  /** The stock id. */
  stock: string;
  factoryDigitalmallBackofficeV1HarddeleteStockRequest: FactoryDigitalmallBackofficeV1HarddeleteStockRequest;
};
export type StockServiceUndeleteStockApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Stock;
export type StockServiceUndeleteStockApiArg = {
  /** The stock id. */
  stock: string;
  factoryDigitalmallBackofficeV1UndeleteStockRequest: FactoryDigitalmallBackofficeV1UndeleteStockRequest;
};
export type StockServiceBatchCreateStocksApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchCreateStocksResponse;
export type StockServiceBatchCreateStocksApiArg = {
  factoryDigitalmallBackofficeV1BatchCreateStocksRequest: FactoryDigitalmallBackofficeV1BatchCreateStocksRequest;
};
export type StockServiceBatchGetStocksApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchGetStocksResponse;
export type StockServiceBatchGetStocksApiArg = {
  /** The names of the books to retrieve. A maximum of 1000 books can be retrieved in a batch. Format: publishers/{publisher}/books/{book} */
  names?: string[];
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type StockServiceBatchUpdateStocksApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchUpdateStocksResponse;
export type StockServiceBatchUpdateStocksApiArg = {
  factoryDigitalmallBackofficeV1BatchUpdateStocksRequest: FactoryDigitalmallBackofficeV1BatchUpdateStocksRequest;
};
export type StoreServiceListStoresApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1ListStoresResponse;
export type StoreServiceListStoresApiArg = {
  /** comment */
  pageSize?: number;
  /** comment */
  pageNumber?: number;
  /** Should follow the Filtering best practices defined by Google AIP here https://google.aip.dev/160 */
  filter?: string;
  /** comment */
  orderBy?: string;
  /** comment */
  showDeleted?: boolean;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type StoreServiceCreateStoreApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Store;
export type StoreServiceCreateStoreApiArg = {
  factoryDigitalmallBackofficeV1Store: FactoryDigitalmallBackofficeV1Store;
};
export type StoreServiceGetStoreApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Store;
export type StoreServiceGetStoreApiArg = {
  /** The store id. */
  store: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type StoreServiceDeleteStoreApiResponse = /** status 200 OK */ string;
export type StoreServiceDeleteStoreApiArg = {
  /** The store id. */
  store: string;
};
export type StoreServiceUpdateStoreApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Store;
export type StoreServiceUpdateStoreApiArg = {
  /** The store id. */
  store: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  updateMask?: string;
  factoryDigitalmallBackofficeV1Store: FactoryDigitalmallBackofficeV1Store;
};
export type StoreServiceHarddeleteStoreApiResponse =
  /** status 200 OK */ string;
export type StoreServiceHarddeleteStoreApiArg = {
  /** The store id. */
  store: string;
  factoryDigitalmallBackofficeV1HarddeleteStoreRequest: FactoryDigitalmallBackofficeV1HarddeleteStoreRequest;
};
export type StoreServiceUndeleteStoreApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1Store;
export type StoreServiceUndeleteStoreApiArg = {
  /** The store id. */
  store: string;
  factoryDigitalmallBackofficeV1UndeleteStoreRequest: FactoryDigitalmallBackofficeV1UndeleteStoreRequest;
};
export type StoreServiceBatchCreateStoresApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchCreateStoresResponse;
export type StoreServiceBatchCreateStoresApiArg = {
  factoryDigitalmallBackofficeV1BatchCreateStoresRequest: FactoryDigitalmallBackofficeV1BatchCreateStoresRequest;
};
export type StoreServiceBatchGetStoresApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchGetStoresResponse;
export type StoreServiceBatchGetStoresApiArg = {
  /** The names of the books to retrieve. A maximum of 1000 books can be retrieved in a batch. Format: publishers/{publisher}/books/{book} */
  names?: string[];
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type StoreServiceBatchUpdateStoresApiResponse =
  /** status 200 OK */ FactoryDigitalmallBackofficeV1BatchUpdateStoresResponse;
export type StoreServiceBatchUpdateStoresApiArg = {
  factoryDigitalmallBackofficeV1BatchUpdateStoresRequest: FactoryDigitalmallBackofficeV1BatchUpdateStoresRequest;
};
export type FactoryDigitalmallBackofficeV1Meta = {
  create_time?: string;
  creation_user?: string;
  update_time?: string;
  update_user?: string;
  delete_time?: string;
  deletion_user?: string;
  sfmc_mid?: number;
  resource_name?: string;
  operation_name?: string;
};
export type FactoryDigitalmallBackofficeV1Mall = {
  name?: string;
  display_name?: string;
  description?: string;
  logo?: string;
  website_uri?: string;
  phone_number?: string;
  opening_hours?: string;
  location_address?: string;
  meta?: FactoryDigitalmallBackofficeV1Meta;
};
export type FactoryDigitalmallBackofficeV1ListMallsResponse = {
  malls?: FactoryDigitalmallBackofficeV1Mall[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
};
export type GoogleProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type GoogleRpcStatus = {
  code?: number;
  message?: string;
  details?: GoogleProtobufAny[];
};
export type FactoryDigitalmallBackofficeV1HarddeleteMallRequest = {
  name: string;
};
export type FactoryDigitalmallBackofficeV1UndeleteMallRequest = {
  name: string;
};
export type FactoryDigitalmallBackofficeV1BatchCreateMallsResponse = {
  malls?: FactoryDigitalmallBackofficeV1Mall[];
};
export type FactoryDigitalmallBackofficeV1CreateMallRequest = {
  mall: FactoryDigitalmallBackofficeV1Mall;
};
export type FactoryDigitalmallBackofficeV1BatchCreateMallsRequest = {
  requests: FactoryDigitalmallBackofficeV1CreateMallRequest[];
};
export type FactoryDigitalmallBackofficeV1BatchGetMallsResponse = {
  malls?: FactoryDigitalmallBackofficeV1Mall[];
};
export type FactoryDigitalmallBackofficeV1BatchUpdateMallsResponse = {
  malls?: FactoryDigitalmallBackofficeV1Mall[];
};
export type FactoryDigitalmallBackofficeV1UpdateMallRequest = {
  mall: FactoryDigitalmallBackofficeV1Mall;
  update_mask?: string;
};
export type FactoryDigitalmallBackofficeV1BatchUpdateMallsRequest = {
  requests: FactoryDigitalmallBackofficeV1UpdateMallRequest[];
};
export type FactoryDigitalmallBackofficeV1Product = {
  name?: string;
  display_name?: string;
  gtin?: string;
  mpn?: string;
  parent_code?: string;
  category?: string;
  sub_category?: string;
  gender?: string;
  review?: string;
  retailer_link?: string;
  image_links?: string[];
  regular_price?: string;
  sale_price?: string;
  description?: string;
  color?: string;
  size?: string;
  material?: string;
  weather?: string;
  fit?: string;
  occasion?: string;
  style?: string;
  temporality?: string;
  season?: string;
  age_group?: string;
  price_range?: string;
  review_count?: number;
  vat?: number;
  ecotax?: number;
  meta?: FactoryDigitalmallBackofficeV1Meta;
};
export type FactoryDigitalmallBackofficeV1ListProductsResponse = {
  products?: FactoryDigitalmallBackofficeV1Product[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
};
export type FactoryDigitalmallBackofficeV1HarddeleteProductRequest = {
  name: string;
};
export type FactoryDigitalmallBackofficeV1UndeleteProductRequest = {
  name: string;
};
export type FactoryDigitalmallBackofficeV1BatchCreateProductsResponse = {
  products?: FactoryDigitalmallBackofficeV1Product[];
};
export type FactoryDigitalmallBackofficeV1CreateProductRequest = {
  product: FactoryDigitalmallBackofficeV1Product;
};
export type FactoryDigitalmallBackofficeV1BatchCreateProductsRequest = {
  requests: FactoryDigitalmallBackofficeV1CreateProductRequest[];
};
export type FactoryDigitalmallBackofficeV1BatchGetProductsResponse = {
  products?: FactoryDigitalmallBackofficeV1Product[];
};
export type FactoryDigitalmallBackofficeV1BatchUpdateProductsResponse = {
  products?: FactoryDigitalmallBackofficeV1Product[];
};
export type FactoryDigitalmallBackofficeV1UpdateProductRequest = {
  product: FactoryDigitalmallBackofficeV1Product;
  update_mask?: string;
};
export type FactoryDigitalmallBackofficeV1BatchUpdateProductsRequest = {
  requests: FactoryDigitalmallBackofficeV1UpdateProductRequest[];
};
export type FactoryDigitalmallBackofficeV1Retailer = {
  name?: string;
  display_name?: string;
  category?: string;
  sub_category?: string;
  description?: string;
  logo?: string;
  website_uri?: string;
  phone_number?: string;
  meta?: FactoryDigitalmallBackofficeV1Meta;
};
export type FactoryDigitalmallBackofficeV1ListRetailersResponse = {
  retailers?: FactoryDigitalmallBackofficeV1Retailer[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
};
export type FactoryDigitalmallBackofficeV1HarddeleteRetailerRequest = {
  name: string;
};
export type FactoryDigitalmallBackofficeV1UndeleteRetailerRequest = {
  name: string;
};
export type FactoryDigitalmallBackofficeV1BatchCreateRetailersResponse = {
  retailers?: FactoryDigitalmallBackofficeV1Retailer[];
};
export type FactoryDigitalmallBackofficeV1CreateRetailerRequest = {
  retailer: FactoryDigitalmallBackofficeV1Retailer;
};
export type FactoryDigitalmallBackofficeV1BatchCreateRetailersRequest = {
  requests: FactoryDigitalmallBackofficeV1CreateRetailerRequest[];
};
export type FactoryDigitalmallBackofficeV1BatchGetRetailersResponse = {
  retailers?: FactoryDigitalmallBackofficeV1Retailer[];
};
export type FactoryDigitalmallBackofficeV1BatchUpdateRetailersResponse = {
  retailers?: FactoryDigitalmallBackofficeV1Retailer[];
};
export type FactoryDigitalmallBackofficeV1UpdateRetailerRequest = {
  retailer: FactoryDigitalmallBackofficeV1Retailer;
  update_mask?: string;
};
export type FactoryDigitalmallBackofficeV1BatchUpdateRetailersRequest = {
  requests: FactoryDigitalmallBackofficeV1UpdateRetailerRequest[];
};
export type FactoryDigitalmallBackofficeV1Service = {
  name?: string;
  display_name?: string;
  category?: string;
  description?: string;
  logo?: string;
  service_uri?: string;
  price?: string;
  location_address?: string;
  mall?: string;
  meta?: FactoryDigitalmallBackofficeV1Meta;
};
export type FactoryDigitalmallBackofficeV1ListServicesResponse = {
  services?: FactoryDigitalmallBackofficeV1Service[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
};
export type FactoryDigitalmallBackofficeV1HarddeleteServiceRequest = {
  name: string;
};
export type FactoryDigitalmallBackofficeV1UndeleteServiceRequest = {
  name: string;
};
export type FactoryDigitalmallBackofficeV1BatchCreateServicesResponse = {
  services?: FactoryDigitalmallBackofficeV1Service[];
};
export type FactoryDigitalmallBackofficeV1CreateServiceRequest = {
  service: FactoryDigitalmallBackofficeV1Service;
};
export type FactoryDigitalmallBackofficeV1BatchCreateServicesRequest = {
  requests: FactoryDigitalmallBackofficeV1CreateServiceRequest[];
};
export type FactoryDigitalmallBackofficeV1BatchGetServicesResponse = {
  services?: FactoryDigitalmallBackofficeV1Service[];
};
export type FactoryDigitalmallBackofficeV1BatchUpdateServicesResponse = {
  services?: FactoryDigitalmallBackofficeV1Service[];
};
export type FactoryDigitalmallBackofficeV1UpdateServiceRequest = {
  service: FactoryDigitalmallBackofficeV1Service;
  update_mask?: string;
};
export type FactoryDigitalmallBackofficeV1BatchUpdateServicesRequest = {
  requests: FactoryDigitalmallBackofficeV1UpdateServiceRequest[];
};
export type FactoryDigitalmallBackofficeV1Stock = {
  name?: string;
  product?: string;
  store?: string;
  in_stock?: boolean;
  stock_level?: number;
  meta?: FactoryDigitalmallBackofficeV1Meta;
};
export type FactoryDigitalmallBackofficeV1ListStocksResponse = {
  stocks?: FactoryDigitalmallBackofficeV1Stock[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
};
export type FactoryDigitalmallBackofficeV1HarddeleteStockRequest = {
  name: string;
};
export type FactoryDigitalmallBackofficeV1UndeleteStockRequest = {
  name: string;
};
export type FactoryDigitalmallBackofficeV1BatchCreateStocksResponse = {
  stocks?: FactoryDigitalmallBackofficeV1Stock[];
};
export type FactoryDigitalmallBackofficeV1CreateStockRequest = {
  stock: FactoryDigitalmallBackofficeV1Stock;
};
export type FactoryDigitalmallBackofficeV1BatchCreateStocksRequest = {
  requests: FactoryDigitalmallBackofficeV1CreateStockRequest[];
};
export type FactoryDigitalmallBackofficeV1BatchGetStocksResponse = {
  stocks?: FactoryDigitalmallBackofficeV1Stock[];
};
export type FactoryDigitalmallBackofficeV1BatchUpdateStocksResponse = {
  stocks?: FactoryDigitalmallBackofficeV1Stock[];
};
export type FactoryDigitalmallBackofficeV1UpdateStockRequest = {
  stock: FactoryDigitalmallBackofficeV1Stock;
  update_mask?: string;
};
export type FactoryDigitalmallBackofficeV1BatchUpdateStocksRequest = {
  requests: FactoryDigitalmallBackofficeV1UpdateStockRequest[];
};
export type FactoryDigitalmallBackofficeV1Store = {
  name?: string;
  display_name: string;
  category?: string;
  sub_category?: string;
  description?: string;
  logo?: string;
  website_uri?: string;
  phone_number?: string;
  location_address?: string;
  opening_hours?: string;
  retailer?: string;
  mall?: string;
  meta?: FactoryDigitalmallBackofficeV1Meta;
};
export type FactoryDigitalmallBackofficeV1ListStoresResponse = {
  stores?: FactoryDigitalmallBackofficeV1Store[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
};
export type FactoryDigitalmallBackofficeV1HarddeleteStoreRequest = {
  name: string;
};
export type FactoryDigitalmallBackofficeV1UndeleteStoreRequest = {
  name: string;
};
export type FactoryDigitalmallBackofficeV1BatchCreateStoresResponse = {
  stores?: FactoryDigitalmallBackofficeV1Store[];
};
export type FactoryDigitalmallBackofficeV1CreateStoreRequest = {
  store: FactoryDigitalmallBackofficeV1Store;
};
export type FactoryDigitalmallBackofficeV1BatchCreateStoresRequest = {
  requests: FactoryDigitalmallBackofficeV1CreateStoreRequest[];
};
export type FactoryDigitalmallBackofficeV1BatchGetStoresResponse = {
  stores?: FactoryDigitalmallBackofficeV1Store[];
};
export type FactoryDigitalmallBackofficeV1BatchUpdateStoresResponse = {
  stores?: FactoryDigitalmallBackofficeV1Store[];
};
export type FactoryDigitalmallBackofficeV1UpdateStoreRequest = {
  store: FactoryDigitalmallBackofficeV1Store;
  update_mask?: string;
};
export type FactoryDigitalmallBackofficeV1BatchUpdateStoresRequest = {
  requests: FactoryDigitalmallBackofficeV1UpdateStoreRequest[];
};
export const {
  useMallServiceListMallsQuery,
  useLazyMallServiceListMallsQuery,
  useMallServiceCreateMallMutation,
  useMallServiceGetMallQuery,
  useLazyMallServiceGetMallQuery,
  useMallServiceDeleteMallMutation,
  useMallServiceUpdateMallMutation,
  useMallServiceHarddeleteMallMutation,
  useMallServiceUndeleteMallMutation,
  useMallServiceBatchCreateMallsMutation,
  useMallServiceBatchGetMallsQuery,
  useLazyMallServiceBatchGetMallsQuery,
  useMallServiceBatchUpdateMallsMutation,
  useProductServiceListProductsQuery,
  useLazyProductServiceListProductsQuery,
  useProductServiceCreateProductMutation,
  useProductServiceGetProductQuery,
  useLazyProductServiceGetProductQuery,
  useProductServiceDeleteProductMutation,
  useProductServiceUpdateProductMutation,
  useProductServiceHarddeleteProductMutation,
  useProductServiceUndeleteProductMutation,
  useProductServiceBatchCreateProductsMutation,
  useProductServiceBatchGetProductsQuery,
  useLazyProductServiceBatchGetProductsQuery,
  useProductServiceBatchUpdateProductsMutation,
  useRetailerServiceListRetailersQuery,
  useLazyRetailerServiceListRetailersQuery,
  useRetailerServiceCreateRetailerMutation,
  useRetailerServiceGetRetailerQuery,
  useLazyRetailerServiceGetRetailerQuery,
  useRetailerServiceDeleteRetailerMutation,
  useRetailerServiceUpdateRetailerMutation,
  useRetailerServiceHarddeleteRetailerMutation,
  useRetailerServiceUndeleteRetailerMutation,
  useRetailerServiceBatchCreateRetailersMutation,
  useRetailerServiceBatchGetRetailersQuery,
  useLazyRetailerServiceBatchGetRetailersQuery,
  useRetailerServiceBatchUpdateRetailersMutation,
  useServiceServiceListServicesQuery,
  useLazyServiceServiceListServicesQuery,
  useServiceServiceCreateServiceMutation,
  useServiceServiceGetServiceQuery,
  useLazyServiceServiceGetServiceQuery,
  useServiceServiceDeleteServiceMutation,
  useServiceServiceUpdateServiceMutation,
  useServiceServiceHarddeleteServiceMutation,
  useServiceServiceUndeleteServiceMutation,
  useServiceServiceBatchCreateServicesMutation,
  useServiceServiceBatchGetServicesQuery,
  useLazyServiceServiceBatchGetServicesQuery,
  useServiceServiceBatchUpdateServicesMutation,
  useStockServiceListStocksQuery,
  useLazyStockServiceListStocksQuery,
  useStockServiceCreateStockMutation,
  useStockServiceGetStockQuery,
  useLazyStockServiceGetStockQuery,
  useStockServiceDeleteStockMutation,
  useStockServiceUpdateStockMutation,
  useStockServiceHarddeleteStockMutation,
  useStockServiceUndeleteStockMutation,
  useStockServiceBatchCreateStocksMutation,
  useStockServiceBatchGetStocksQuery,
  useLazyStockServiceBatchGetStocksQuery,
  useStockServiceBatchUpdateStocksMutation,
  useStoreServiceListStoresQuery,
  useLazyStoreServiceListStoresQuery,
  useStoreServiceCreateStoreMutation,
  useStoreServiceGetStoreQuery,
  useLazyStoreServiceGetStoreQuery,
  useStoreServiceDeleteStoreMutation,
  useStoreServiceUpdateStoreMutation,
  useStoreServiceHarddeleteStoreMutation,
  useStoreServiceUndeleteStoreMutation,
  useStoreServiceBatchCreateStoresMutation,
  useStoreServiceBatchGetStoresQuery,
  useLazyStoreServiceBatchGetStoresQuery,
  useStoreServiceBatchUpdateStoresMutation,
} = injectedRtkApi;
